import { history } from 'helpers';
import { useMemo } from 'react';

export const useIsBackoffice = () => {
    return useMemo(() => history.location.pathname.includes('backoffice'), []);
};
